import React from "react";
import { Controller } from "../Controller";
import cname from "../../style.module.scss";
import { Accordian } from "@learningblocks/storybook-components";
import { DataTable } from "@learningblocks/shared-components";
import { ACCORDIAN_SMALL } from "../../Spectrophotometer.utils";
import { AbsorbanceTable } from "../../types";

interface ContentProps {
  /**
   * Boolean to set if spectrophotometer is on/off
   */
  poweredUp: boolean;
  /**
   * Absorbance value of solution inside the cuvette
   */
  absorbanceValue: number;
  /**
   * Relative absorbance value set
   */
  relativeAbsorbance: number;
  /**
   * Callback for PowerButton click
   */
  onClickPowerButton: () => void;
  /**
   * Callback for ZeroButton click
   */
  onClickZeroButton: () => void;
  /**
   * Current wavelenght
   */
  wavelength: number;
  /**
   * Callback function to set wavelength value
   */
  setWavelength: (wavelength: number) => void;
  /**
   * The ID of the cuvette.
   */
  cuvetteId?: string;
  /**
   * absorbanceTable - The absorbance table data
   * @type AbsorbanceTable
   */
  absorbanceTable: AbsorbanceTable;
  /**
   * @prop absorbanceTableCellUpdate - Function to update the absorbance table cell.
   * @param {any} value - The new value for the absorbance table cell.
   * @type (value: any) => void
   */
  absorbanceTableCellUpdate: (value: { id: string; value: string }) => void;
}

export function Content(props: ContentProps) {
  const [accordian, updateAccordian] = React.useState(ACCORDIAN_SMALL);

  const onSelectTab = (tabId: number) => {
    const selectTab = (tab: {
      id: number;
      label: string;
      description: string;
    }) => {
      if (tab.id === tabId) return { ...tab, open: true };
      else return { ...tab, open: false };
    };
    updateAccordian((acc) => acc.map(selectTab));
  };

  const status = props.cuvetteId ? "Yes" : "No";

  return (
    <>
      <div className={cname.left}>
        <p className={cname.text}>Set the spectrophotometer</p>
        <p style={{ marginTop: 0 }}>
          Use the second column [Abs (400 nm)] to record your absorbance value
          for substance S. The value will be rounded to 2 decimal points.
        </p>
        <DataTable
          className={cname.dataTable}
          indices={props.absorbanceTable.indices}
          data={props.absorbanceTable.data}
          onCellChange={(e: any) => {
            props.absorbanceTableCellUpdate(e);
          }}
        />
        <Accordian
          className={cname.accordian}
          allTabs={accordian}
          onSelectTab={onSelectTab}
        />
        <div className={cname[`status_${status}`]}>
          <p>Cuvette Inserted: {status}</p>
        </div>
      </div>
      <div className={cname.right}>
        <Controller
          poweredUp={props.poweredUp}
          wavelength={props.wavelength}
          setWavelength={props.setWavelength}
          absorbanceValue={props.absorbanceValue}
          onClickZeroButton={props.onClickZeroButton}
          relativeAbsorbance={props.relativeAbsorbance}
          onClickPowerButton={props.onClickPowerButton}
        />
      </div>
    </>
  );
}
